import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';

const StyledDiv = styled('div', {
  backgroundColor: '#FFFFFF',
  border: ({ theme }) => {
    return `2px solid ${theme.colors.gray200}`;
  },
  marginRight: '10',
  height: '100%',
});

export const SideNavProvider = ({ children }) => {
  return <StyledDiv>{children}</StyledDiv>;
};

SideNavProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
